
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/vistar-media",
      function () {
        return require("private-next-pages/destinations/vistar-media.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/vistar-media"])
      });
    }
  